import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
function AttachmentForm({ formData, onFileChange }) {
  const { formField, values, errors, touched, setFieldValue } = formData; // Assuming setFieldValue is passed for updating form values
  const { logoUrl, enProfileUrl, arProfileUrl } = formField;
  const { logoUrl: logoUrlV, enProfileUrl: enProfileUrlV, arProfileUrl: arProfileUrlV } = values;
  const handleFileChange = (event, name) => {
    const file = event.target.files[0];
    if (file) {
      // Update the form values

      if (setFieldValue) {
        setFieldValue(name, file); // Assuming setFieldValue follows the same pattern as Formik
      }

      // Trigger the callback if provided
      if (onFileChange) {
        onFileChange(name, file);
      }
    }
  };

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">المعلومات الرئيسية</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <MDTypography variant="subtitle2">{logoUrl.label}</MDTypography>
            <TextField
              type="file"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleFileChange(e, logoUrl.name)}
              error={Boolean(errors.logoUrl && touched.logoUrl)}
              helperText={errors.logoUrl && touched.logoUrl ? errors.logoUrl : ""}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDTypography variant="subtitle2">{enProfileUrl.label}</MDTypography>
            <TextField
              type="file"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleFileChange(e, enProfileUrl.name)}
              error={Boolean(errors.enProfileUrl && touched.enProfileUrl)}
              helperText={errors.enProfileUrl && touched.enProfileUrl ? errors.enProfileUrl : ""}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDTypography variant="subtitle2">{arProfileUrl.label}</MDTypography>
            <TextField
              type="file"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleFileChange(e, arProfileUrl.name)}
              error={Boolean(errors.arProfileUrl && touched.arProfileUrl)}
              helperText={errors.arProfileUrl && touched.arProfileUrl ? errors.arProfileUrl : ""}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

AttachmentForm.propTypes = {
  formData: PropTypes.shape({
    formField: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func, // Function to update form field values
  }).isRequired,
  onFileChange: PropTypes.func, // Prop type for file change handler
};

export default AttachmentForm;
